import { useEffect } from 'react';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useJswOnboarding } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import type { ProjectContext as ProjectContextType } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { useRefreshOnJSMProjectSwitch } from '../refresh-on-jsm-project-switch/index.tsx';

export const useRefreshQuickstartOnProjectSwitch = (
	projectContextData: ProjectContextType | null,
): void => {
	const [{ quickstartStateProjectType }, { resetIsQuickstartLoaded }] = useJswOnboarding();
	// Handles JSM projects
	useRefreshOnJSMProjectSwitch(projectContextData?.projectId, projectContextData?.projectType);

	// Handles all other non JSM project types
	useEffect(() => {
		if (
			projectContextData?.projectType !== SERVICE_DESK_PROJECT &&
			quickstartStateProjectType !== projectContextData?.projectType
		) {
			resetIsQuickstartLoaded();
		}
	}, [resetIsQuickstartLoaded, projectContextData?.projectType, quickstartStateProjectType]);
};
